import React from 'react';
import { ButtonProps } from '@mui/material';

import { StyledButton } from './styles';

interface IButton extends ButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  width?: string;
  maxWidth?: string;
}

export const Button: React.FC<IButton> = ({
  className,
  children,
  onClick,
  disabled = false,
  variant = 'contained',
  type = 'button',
  width,
  maxWidth,
  ...props
}) => {
  return (
    <StyledButton
      className={className}
      disabled={disabled}
      variant={variant}
      onClick={onClick}
      type={type}
      width={width}
      $maxWidth={maxWidth}
      {...props}
    >
      {children}
    </StyledButton>
  );
};
